exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes fade-in---2gOB7{0%{opacity:0}100%{opacity:1}}.activity---3TQhw{width:calc(100% - 264px);margin:0 5px 0 40px;background-color:#fff;border-radius:16px;position:relative}.activity---3TQhw .flag-toggle---1YOuD{position:absolute;right:15px;top:-8px;z-index:5}.activity---3TQhw .inner-scroll---3pgVP{overflow-y:auto;padding:30px 34px;width:100%;height:100%;position:absolute}.activity---3TQhw .tri---2d0yw{position:absolute;right:0;bottom:0;transform:translate(0, 100%)}@media only screen and (max-width: 800px){.activity---3TQhw{width:calc(100% - 118px);margin:0 40px}.activity---3TQhw .flag-toggle---1YOuD{right:32px}}.disable-element---1GUFC{pointer-events:none}[class*=\"MenuPortal\"]{z-index:100 !important}[class*=\"quest-select\"]{z-index:100 !important}#react-select-35-listbox{z-index:100 !important}", ""]);

// exports
exports.locals = {
	"activity": "activity---3TQhw",
	"flag-toggle": "flag-toggle---1YOuD",
	"inner-scroll": "inner-scroll---3pgVP",
	"tri": "tri---2d0yw",
	"disable-element": "disable-element---1GUFC",
	"fade-in": "fade-in---2gOB7"
};